/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
export default function createNotificationSystem(options = {}) {
  const shownPaintEmptyAlerts = new Set();
  let currentToast = null;
  let currentTimeout = null;
  let removeTimeout = null;
  function clearCurrentToast() {
      if (currentToast) {
        if (currentToast.parentNode) {
          currentToast.parentNode.removeChild(currentToast);
        }
        currentToast = null;
      }
      if (currentTimeout) clearTimeout(currentTimeout);
      if (removeTimeout) clearTimeout(removeTimeout);
    }
    function showToast(text, icon = '🔔', duration = 2000) {
      clearCurrentToast();
      const toast = document.createElement('div');
      toast.className = 'paint-empty-toast';
      toast.innerHTML = `
        <div class="toast-content">
          <span class="toast-text">${text}</span>
          <span class="toast-icon">${icon}</span>
        </div>
      `;
      document.body.appendChild(toast);
      currentToast = toast;
      setTimeout(() => {
        toast.classList.add('show');
      }, 10);
      currentTimeout = setTimeout(() => {
        toast.classList.remove('show');
        removeTimeout = setTimeout(() => {
          if (toast && toast.parentNode) {
            toast.parentNode.removeChild(toast);
          }
          if (currentToast === toast) currentToast = null;
        }, 300);
      }, duration);
    }
  function showPaintEmptyToast(canId) {
    if (shownPaintEmptyAlerts.has(canId)) return;
    shownPaintEmptyAlerts.add(canId);
    if (typeof window !== 'undefined' && typeof window.triggerPaintEmptyAlert === 'function') {
      window.triggerPaintEmptyAlert(canId);
      setTimeout(() => {
        shownPaintEmptyAlerts.delete(canId);
      }, 5000);
      return;
    }
    const msg = (options.getTranslation && options.lang)
      ? options.getTranslation(options.lang, 'alertEmptyCan')
      : 'Краска закончилась в баллоне';
    showToast(`${msg} ${canId}`, '🫠', 3000);
    setTimeout(() => {
      shownPaintEmptyAlerts.delete(canId);
    }, 5000);
  }
  return {
    showPaintEmptyToast,
    showToast
  };
}
